import { CoreCOMService } from "../services/com.service";
import { StorageCleaner } from "../shared/storageCleaner";
import { UserLoginStatusProvider } from "./userLoginStatusProvider";
import { StatusBarProvider } from "./statusBarProvider";
import { NavigationBarProvider } from "./NavigationBarProvider";

/**
 * provider factory to initialize the application
 * @param provider this provider uses APP_INITIALIZER token in appmodule --> Provider and runs when application is loaded
 */
export function appInitializeProviderFactory(coreCOMService: CoreCOMService, userLoginStatusProvider: UserLoginStatusProvider): () => Promise<void> {
    return () => <Promise<void>>(new Promise<void>(async (resolve, reject) => {
        // before first acces to storage StorageCleaner.Update must run
        try {
            await StorageCleaner.Update(coreCOMService);
        } catch (error) {
            console.error("AppInitialize StorageUpdate Failed", error);
        }
        // try use local storage data to keeps logt in
        try {
            await userLoginStatusProvider.checkLoginStatus();
        } catch (error) {
            console.error("AppInitialize CheckLoginStatus Failed", error);
        }
        resolve();
    }));
}

/**
 * provider factory to set statusBar background color
 * @param provider this provider uses APP_INITIALIZER token in appmodule --> Provider and runs when application is loaded
 */
export function statusBarBackgroundProviderFactory(provider: StatusBarProvider): () => Promise<void> {
    return () => <Promise<void>>provider.SetStausBarBackgroundStyle()
        .catch((error) => {
            console.error("StatusBar SetStausBarBackgroundStyle Failed", error);
        });
}

/**
 * provider factory to run set statusBar text color
 * @param provider this provider uses APP_INITIALIZER token in appmodule --> Provider and runs when application is loaded
 */
export function statusBarTextProviderFactory(provider: StatusBarProvider): () => Promise<void> {
    return () => <Promise<void>>provider.SetStausBarTextStyle()
        .catch((error) => {
            console.error("StatusBar statusBarTextProviderFactory Failed", error);
        });
}

/**
 * provider factory to run set statusBar text color
 * @param provider this provider uses APP_INITIALIZER token in appmodule --> Provider and runs when application is loaded
 */
export function backgroundColorByHexString(provider: NavigationBarProvider): () => Promise<void> {
    return () => <Promise<void>>provider.backgroundColorByHexString()
        .catch((error) => {
            console.error("NavigationBar backgroundColorByHexString Failed", error);
        });
}
